import { render, staticRenderFns } from "./ListReferrals.vue?vue&type=template&id=1c5b86aa&"
import script from "./ListReferrals.vue?vue&type=script&lang=js&"
export * from "./ListReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports